import { FetchInterceptor } from "src/app/helpers/Index";
import { environment } from "src/environments/environment";
import { Service } from "./Service";

const endpoint = "Formation";
export const FormationService = {
	endpoint,
	createSingle: async (data: any) => await Service.createSingle(endpoint, data),
	deleteSingleById: async (id: number) => await Service.deleteSingleById(endpoint, id),
	getAll: async () => await Service.getAll(endpoint),
	getLatest: async () => await FetchInterceptor(`${environment.server.apiURL}/${endpoint}/GetLatest/`, {headers: {"Content-Type": "application/json"}, method: "GET"}),
	updateSingleById: async (id: number, data: any) => await Service.updateSingleById(endpoint, id, data)
}
